import React from 'react';
import s from './ReturnStatus.module.scss';
import { ReactComponent as StatusIcon } from 'images/new-icons/order-status-done.svg';
import { TryotoStatusList } from 'modules/product/pages/OrderDetails/tryotoStatusList.enum';

const formatDate = dateString => {
  const options = {
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  };
  const date = new Date(dateString);
  //@ts-ignore
  return date.toLocaleString('en-US', options).replace(',', '');
};

const Status = ({ date, status }) => {
  return (
    <div className={s.status}>
      <div className={s.status__icon}>
        <div
          style={{
            width: 16,
            height: 16,
            borderRadius: 100,
            background: '#FCE967',
            marginTop: '8px',
          }}
        />
      </div>
      <div className={s.status__info}>
        <div className={s.status__info_date}>{formatDate(date)}</div>
        <div className={s.status__info_status}>{TryotoStatusList[status]}</div>
      </div>
    </div>
  );
};

export default Status;
